import React, { useState } from 'react';
import { 
  Table, Card, Form, Input, Select, Button, 
  DatePicker, Space, Typography, Tag
} from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text, Title } = Typography;

// 来源类型映射
const SOURCE_TYPE_MAP = {
  purchase: { label: '企业采购', color: 'blue' },
  directTopup: { label: '平台直充', color: 'green' },
  directRefund: { label: '平台退款', color: 'orange' },
};

const ProduceAuthPurchase = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // 模拟数据
  const mockData = [
    {
      key: '1',
      sourceType: 'purchase',
      orderNo: 'PA202603230001',
      productName: '智能摄像机 Q1',
      productId: 'PROD_001',
      quantity: 1000,
      price: 15.50,
      totalAmount: 15500.00,
      purchaseTime: '2026-03-23 10:00:00',
      workOrderName: 'Q1首批生产工单',
      workOrderId: 'WO_20260323_001'
    },
    {
      key: '2',
      sourceType: 'directTopup',
      productName: '智能摄像机 Q1',
      productId: 'PROD_001',
      quantity: 5000,
      purchaseTime: '2026-05-20 14:30:00',
    },
    {
      key: '3',
      sourceType: 'purchase',
      orderNo: 'PA202603220055',
      productName: '双目室外机 W2',
      productId: 'PROD_W2',
      quantity: 500,
      price: 45.00,
      totalAmount: 22500.00,
      purchaseTime: '2026-03-22 14:30:00',
      workOrderName: 'W2出口版追加工单',
      workOrderId: 'WO_20260322_012'
    },
    {
      key: '4',
      sourceType: 'directTopup',
      productName: '双目室外机 W2',
      productId: 'PROD_W2',
      quantity: 10000,
      purchaseTime: '2026-05-19 10:15:00',
    },
    {
      key: '6',
      sourceType: 'directRefund',
      productName: '双目室外机 W2',
      productId: 'PROD_W2',
      quantity: 500,
      purchaseTime: '2026-05-19 10:30:00',
    },
    {
      key: '6',
      sourceType: 'purchase',
      orderNo: 'PA202603210088',
      productName: '4G云台机 C201',
      productId: 'PROD_C201',
      quantity: 2000,
      price: 12.80,
      totalAmount: 25600.00,
      purchaseTime: '2026-03-21 09:15:00',
      workOrderName: 'C201常规生产计划',
      workOrderId: 'WO_20260321_005'
    }
  ];

  const columns = [
    {
      title: '来源类型',
      dataIndex: 'sourceType',
      key: 'sourceType',
      width: 110,
      render: (val) => {
        const config = SOURCE_TYPE_MAP[val];
        return <Tag color={config.color} style={{ border: 'none' }}>{config.label}</Tag>;
      }
    },
    {
      title: '时间',
      dataIndex: 'purchaseTime',
      key: 'purchaseTime',
      width: 170,
      defaultSortOrder: 'descend',
      sorter: (a, b) => (a.purchaseTime || '').localeCompare(b.purchaseTime || ''),
    },
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      key: 'orderNo',
      width: 180,
      render: (val) => val || <span style={{ color: '#ccc' }}>—</span>,
    },
    {
      title: '产品信息',
      key: 'productInfo',
      width: 200,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: 500 }}>{record.productName}</div>
          <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.productId}</Text>
        </div>
      )
    },
    {
      title: '数量',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      width: 100,
      render: (val, record) => {
        if (record.sourceType === 'directRefund') {
          return <span style={{ color: '#ff4d4f' }}>-{val.toLocaleString()}</span>;
        }
        return val.toLocaleString();
      }
    },
    {
      title: '采购单价(CNY)',
      dataIndex: 'price',
      key: 'price',
      align: 'right',
      width: 130,
      render: (val) => val ? `¥${val.toFixed(2)}` : <span style={{ color: '#ccc' }}>—</span>
    },
    {
      title: '总价(CNY)',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'right',
      width: 120,
      render: (val) => val ? <Text strong>¥{val.toFixed(2)}</Text> : <span style={{ color: '#ccc' }}>—</span>
    },
    {
      title: '关联工单',
      key: 'workOrderInfo',
      width: 200,
      render: (_, record) => {
        if (record.workOrderName) {
          return (
            <div>
              <div>{record.workOrderName}</div>
              <Text type="secondary" style={{ fontSize: 12 }}>ID: {record.workOrderId}</Text>
            </div>
          );
        }
        return <span style={{ color: '#ccc' }}>—</span>;
      }
    },
  ];

  const onReset = () => {
    form.resetFields();
  };

  const onSearch = () => {
    setLoading(true);
    // 模拟搜索
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>生产授权采购</Title>
      </div>

      <Card style={{ marginBottom: 16 }}>
        <Form form={form} layout="inline">
          <Form.Item>
            <Space.Compact>
              <Form.Item name="searchType" initialValue="productName" noStyle>
                <Select style={{ width: 120 }}>
                  <Option value="productName">产品名称</Option>
                  <Option value="productId">产品ID</Option>
                </Select>
              </Form.Item>
              <Form.Item name="searchValue" noStyle>
                <Input placeholder="请输入关键字" style={{ width: 200 }} allowClear />
              </Form.Item>
            </Space.Compact>
          </Form.Item>

          <Form.Item name="sourceType" style={{ marginBottom: 0 }}>
            <Select placeholder="来源类型" allowClear style={{ width: 140 }}>
              <Option value="purchase">企业采购</Option>
              <Option value="directTopup">平台直充</Option>
              <Option value="directRefund">平台退款</Option>
            </Select>
          </Form.Item>

          <Form.Item name="purchaseTime" label="时间">
            <RangePicker />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={onSearch}>
                查询
              </Button>
              <Button icon={<ReloadOutlined />} onClick={onReset}>
                重置
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <Table
          columns={columns}
          dataSource={mockData}
          rowKey="key"
          loading={loading}
          pagination={{
            showTotal: (total) => `共 ${total} 条记录`,
            pageSize: 10,
          }}
        />
      </Card>
    </div>
  );
};

export default ProduceAuthPurchase;
